import React from "react";
import { gettext, View } from "../shared/utils/legacy";
import { Modal } from "react-bootstrap";
import ModalHeader from "../shared/components/ModalHeader";

const ReportConfigurationModal = ({
  show,
  handleClose,
  configKey,
}: {
  show: boolean;
  handleClose: () => void;
  configKey: string;
}) => {
  const showConfig = () => {
    let x = new View.FarmConfigurationView({ callback: handleClose });
    //@ts-ignore
    x.render({ configuration_type: configKey });
  };

  return (
    <Modal
      className="modal-md dfi-modal"
      show={show}
      onHide={handleClose}
      onShow={showConfig}
      data-backdrop={true}
    >
      <ModalHeader title={gettext("Configuration")} />
      <Modal.Body className="pb-0">
        <div id="configuration-content"></div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

export default ReportConfigurationModal;
